import {
  USER_PR_PERMISSION_FETCHING,
  USER_PR_PERMISSION_SUCCESS,
  USER_PR_PERMISSION_FAIL,
  USER_BUDGET_PERMISSION_FETCHING,
  USER_BUDGET_PERMISSION_SUCCESS,
  USER_BUDGET_PERMISSION_FAIL,
  MENU_SYSTEM_FETCHING,
  MENU_SYSTEM_SUCCESS,
  MENU_SYSTEM_FAIL,
} from "./../../Constants";

const initialState = {
  permissionBudget: {
    data: [{ roles: [], rights: [] }],
    isLoading: false,
    isError: false,
  },
  authorizePR: {
    data: [{ roles: [], doaroles: [], rights: [] }],
    isLoading: false,
    isError: false,
  },
  menu: {
    data: [],
    isLoading: false,
    isError: false,
  },
  delegateRoles: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case MENU_SYSTEM_FETCHING:
      return {
        ...state,
        menu: {
          data: [],
          isLoading: true,
          isError: false,
        },
      };
    case MENU_SYSTEM_SUCCESS:
      return {
        ...state,
        menu: {
          data: payload,
          isLoading: false,
          isError: false,
        },
      };
    case MENU_SYSTEM_FAIL:
      return {
        ...state,
        menu: {
          data: [],
          isLoading: false,
          isError: true,
        },
      };

    case USER_BUDGET_PERMISSION_FETCHING:
      return {
        ...state,
        permissionBudget: {
          data: [],
          isLoading: true,
          isError: false,
        },
      };
    case USER_BUDGET_PERMISSION_SUCCESS:
      return {
        ...state,
        permissionBudget: {
          data: payload,
          isLoading: false,
          isError: false,
        },
      };

    case USER_BUDGET_PERMISSION_FAIL:
      return {
        ...state,
        permissionBudget: {
          data: [],
          isLoading: false,
          isError: true,
        },
      };

    case USER_PR_PERMISSION_FETCHING:
      return {
        ...state,
        authorizePR: {
          data: [],
          isLoading: true,
          isError: false,
        },
      };
    case USER_PR_PERMISSION_SUCCESS:
      return {
        ...state,
        authorizePR: {
          data: payload,
          isLoading: false,
          isError: false,
        },
      };

    case USER_PR_PERMISSION_FAIL:
      return {
        ...state,
        authorizePR: {
          data: [],
          isLoading: false,
          isError: true,
        },
      };
    case "USER_DELEGATE_ROLE_FETCH":
      return {
        ...state,
        delegateRoles: {
          data: [],
          isLoading: true,
          isRejected: false,
        },
      };
    case "USER_DELEGATE_ROLE_SUCCESS":
      return {
        ...state,
        delegateRoles: {
          data: payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case "USER_DELEGATE_ROLE_REJECTED":
      return {
        ...state,
        delegateRoles: {
          data: [],
          isLoading: false,
          isRejected: true,
        },
      };
    default:
      return state;
  }
};
